// extracted by mini-css-extract-plugin
export var servicesbg = "Service-module--servicesbg--etxr8";
export var servicesborder = "Service-module--servicesborder--ZGSDn";
export var servicesbox = "Service-module--servicesbox--iy3wx";
export var servicesdata = "Service-module--servicesdata--3LVce";
export var servicesdataname = "Service-module--servicesdataname--H8iqA";
export var textgray = "Service-module--textgray--S2ukQ";